import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const ParkableDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Parkable,
  hasCustomUI: false,
  friendlyName: 'Parkable',
  description:
    'Defines the properties required for the Parkable public notifications integration.',
  category: IntegrationCategoryEnum.Parking,
  platforms: [PlatformEnum.Web, PlatformEnum.Mobile],
  type: IntegrationTypeEnum.Api,
  settings: {
    auth0ClientId: {
      friendlyName: 'Auth0 Client ID',
      description: 'M2M client ID used to authorize Parkable API requests.',
      type: 'String',
      editable: true,
      validators: [{ name: 'Required', value: true }],
    },
  },
  properties: {},
};

export const definition = ParkableDefinition;
